export default "__VITE_ASSET__6d9a33cf__"